import Swiper from 'swiper/bundle';
import MicroModal from 'micromodal';
// import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock'; // NOTE iOSでbodyのwidthがおかしくなる
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

type GalleryCarousel = {
    targetGallerySwiperStructureClassName: string,
    targetGalleryDataSwiperStructureClassName: string,
    GalleryThumbnailSwiper: Swiper,
};

type GalleryThumbnailCarousel = {
    parent: object,
    targetSwiperStructureClassName: string,
};

type GalleryThumbnailList = {
    parent: Swiper,
    targetClassName: string,
};

const settings = {
    effect: 'fade',
    speed: 1500
};

/**
 *
 */
const GalleryThumbnailTile = (options: GalleryThumbnailList) => {
    const {parent, targetClassName} = options;
    const classNameMap = {
        'active': '-active'
    };
    const thumbnailItems = document.querySelectorAll(targetClassName);
    const currentTo = (elms: NodeListOf<Element>, currentIndex: number) => {
        console.log(elms, currentIndex);

        [...elms].forEach((elm, index) => {
            if (currentIndex === index) {
                elm.classList.add(classNameMap.active);
            } else {
                elm.classList.remove(classNameMap.active);
            }
        });
    };
    /**
     * parentSwiperのアクティブインデックスと同期させる
     * @param parentSwiper Swiper
     */
    const syncParentSlideIndex = (parentSwiper: Swiper) => {
        const currentSlideIndex = parentSwiper.activeIndex;
        currentTo(thumbnailItems, currentSlideIndex);
    }
    /**
     * スライドインタラクション
     * @param e
     */
    const initClickThumbnailTile = (e) => {
        const index = e.currentTarget?.dataset?.slideto;

        if (index) {
            parent.slideTo(index, settings.speed, false);
        }
    };

    /**
     * .on('slideChange')に設定する関数
     */
    return {
        /**
         * 初期化
         */
        init: () => {
            /**
             * 各サムネイルにparentのスライド切り替えを実行させるイベントを登録
             */
            console.log(thumbnailItems);
            if (!thumbnailItems) return;
            /**
             * 各サムネイルにparentのスライド切り替えを実行させるイベントを登録
             */
            [...thumbnailItems].forEach((elm) => {
                elm.addEventListener('click', initClickThumbnailTile, false);
            });
            /**
             * parentSwiperのスライドインデックスを同期させる
             */
            syncParentSlideIndex(parent);
        },
        /**
         * parentSwiperのslideChangeイベントに設定する関数
         * @param parentSwiper
         */
        forParentSwiperSlideChangeHandler: (parentSwiper: Swiper) => {
            syncParentSlideIndex(parentSwiper);
        }
    }
};

/**
 * Swiperのサムネイルリストを作る
 * @param options
 */
const initGalleryThumbnailCarousel = (options: GalleryThumbnailCarousel) => {
    const {targetSwiperStructureClassName} = options;
    return new Swiper(targetSwiperStructureClassName, {
        // effect: 'fade',
        loop: false,
        spaceBetween: 24,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.js-studentWorksGalleryThumbnailsNext',
            prevEl: '.js-studentWorksGalleryThumbnailsPrev'
        }
    });
};

const initGalleryCarousel = (options: GalleryCarousel): Swiper => {
    const {
        targetGallerySwiperStructureClassName,
        targetGalleryDataSwiperStructureClassName,
        GalleryThumbnailSwiper
    } = options;
    // @ts-ignore
    /**
     * 作品情報ブロック要
     */
        // @ts-ignore
    const sliderDetail: Swiper = new Swiper(targetGalleryDataSwiperStructureClassName, {
            effect: settings.effect,
            speed: settings.speed,
            slidesPerView: 1,
            grabCursor: false,
            autoplay: false,
            allowTouchMove: false
        });
    /**
     * ギャラリー本体
     */
        // @ts-ignore
    const swiper: Swiper = new Swiper(targetGallerySwiperStructureClassName, { // eslint-disable-line
            thumbs: {
                swiper: GalleryThumbnailSwiper
            },
            effect: settings.effect,
            loop: false,
            speed: settings.speed,
            autoplay: false,
            allowTouchMove: true,
            navigation: {
                nextEl: '.js-studentWorksGalleryNext',
                prevEl: '.js-studentWorksGalleryPrev'
            },
            on: {
                slideChange(swiper) {
                    console.log(sliderDetail);
                    console.log('slide index', swiper.activeIndex);
                    sliderDetail.slideTo(swiper.activeIndex);
                }
            },
            autoHeight: false
        });

    console.log(swiper);
    return swiper;
};

const initSlideModal = (): void => {
    MicroModal.init({
        // NOTE ライブラリのポリシーによりモダンな対策処理が不十分のため、disableScrollは自前で対策する必要がある
        // @see https://github.com/ghosh/Micromodal/pull/102
        // @see https://github.com/ghosh/Micromodal/issues/138
        onShow: modal => disablePageScroll(modal),
        onClose: modal => enablePageScroll(modal),
        // disableScroll: true,
        disableFocus: true
    });
}

export const studentWorksGallery = (): void => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (function (window, document) {
        const targetGallerySwiperStructureClassName = '.js-studentWorksGallery';
        const targetGalleryThumbnailsSwiperStructureClassName = '.js-studentWorksGalleryThumbnails';
        const targetGalleryDataSwiperStructureClassName = '.js-studentWorksGalleryDetails';
        const targetThumbnailTileClassName = '.js-studentWorksGalleryThumbnailList';
        const sliderThumbnailDestroyBreakpoint: string | null = getComputedStyle(document.documentElement)?.getPropertyValue("--global-breakpoint--full");
        const sliderThumbnailsDestroyBreakpoint = window.matchMedia(`(min-width: ${sliderThumbnailDestroyBreakpoint})`);
        console.log(sliderThumbnailsDestroyBreakpoint);
        // const activePageClass = '-active';
        /**
         * ギャラリー本体が無いなら処理停止
         */
        const target = document.querySelector(targetGallerySwiperStructureClassName);
        if (!target) return;
        /**
         * Init
         */
            // @ts-ignore
        const GalleryThumbnailCarousel = initGalleryThumbnailCarousel({
                targetSwiperStructureClassName: targetGalleryThumbnailsSwiperStructureClassName
            });
        const GalleryCarousel = initGalleryCarousel({
            targetGallerySwiperStructureClassName,
            targetGalleryDataSwiperStructureClassName,
            GalleryThumbnailSwiper: GalleryThumbnailCarousel
        });
        try {
            if (!GalleryCarousel || !GalleryThumbnailCarousel) throw 'Swiperがinitializeできません';
        } catch (e) {
            console.error(e);
        }
        /**
         * サムネモーダル
         */
        initSlideModal();
        /**
         * サムネイルタイルとGalleryを同期させる
         */
        const GalleryThumbnailTileForParent = GalleryThumbnailTile({
            parent: GalleryCarousel,
            targetClassName: targetThumbnailTileClassName
        });
        GalleryThumbnailTileForParent.init();
        GalleryCarousel.on('slideChange', GalleryThumbnailTileForParent.forParentSwiperSlideChangeHandler);

        // TODO on-offのコードは、とりあえず全実行可能状態になってから
        // const handleMediaQuery = (mediaQuery) => {
        //     if (mediaQuery.matches) {
        //         console.log(GalleryThumbnailSwiper);
        //         console.log(GalleryThumbnailSwiper instanceof Swiper);
        //         if (GalleryThumbnailSwiper instanceof Swiper) {
        //             GalleryThumbnailSwiper.destroy();
        //             GalleryThumbnailSwiper = null;
        //
        //             swiper.on('slideChange', ClinkThumbHandler);
        //         }
        //     } else {
        //         if (GalleryThumbnailSwiper) return;
        //         GalleryThumbnailSwiper = initGalleryThumbnailCarousel({
        //             targetSwiperStructureClassName: targetGallerySwiperStructureClassName
        //         });
        //         swiper.off('slideChange', ClinkThumbHandler);
        //     }
        // };
        // Register
        // handleMediaQuery(sliderThumbnailsDestroyBreakpoint);
        // sliderThumbnailsDestroyBreakpoint.addListener(handleMediaQuery);


    })(window, document);
};